export const isMobileSafari = function identifySafariMobile() {
  let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if(isSafari && iOS) {
    //alert(true)
    return true
  }
  else {
   // alert(false)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/helper/identifySafariMobile.js